<template>
<div>
	<ul class="title-nav">
		<li>
			<div v-on:click="routeBack()" class="back-btn">
				<i class="material-icons md-18">keyboard_arrow_left</i>
			</div> 
			
			<div class="title-label"><i class="material-icons md-18">group</i> TEAM</div>
		</li>
	</ul>

	<div class="category">
		<div class="category-title">TEAM MEMBERS</div>
		<div class="property-row">
			teammember1@email.com
			<a v-on:click="deleteShow" href="javascript:" class="float-right text-secondary">x</a>
		</div>
		<div class="property-row">
			teammember1@email.com
			<span class="badge badge-dark">pending</span>
			<a v-on:click="deleteShow" href="javascript:" class="float-right text-secondary">x</a>
		</div>
		<div v-if="mode == 'view'" class="property-row">
			<button v-on:click="editShow" class="btn btn-light btn-sm float-right">Add Member</button>
		</div>
	</div>

	<form v-if="mode == 'edit'" class="category form-group" v-on:submit.prevent="submitChange">
		<div class="category-title" for="signUpEmail">ADD TEAM MEMBER</div>
		<div class="property-row">
			<input type="email" class="form-control" id="email" aria-describedby="emailHelp" 
				placeholder="Enter team member email" v-model="newMemberEmail"
				v-bind:class="{'is-invalid':error}"/>
			<div class="invalid-feedback">
				{{error}}
		   </div>
		</div>
		<div class="property-row">
			<button v-on:click="editCancel" class="btn btn-light">Cancel</button>
			<button class="btn btn-dark float-right" type="submit">Send Invite</button>
		</div>
	</form>
</div>

</template>

<script>

export default {
	data: function(){
		return {
			error:null,
			mode:'view',
			newMemberEmail:'',
		}
	},
	props: {
		agent:{
			type:Object
		},
	},
	methods:{
		routeBack:function(){
			this.$router.push({
				name:'agent',
			});
		},
		deleteShow:function(){

		},
		editCancel:function(){
			this.mode = 'view';
		},
		editShow:function(){
			this.mode = 'edit';
		},
		submitChange:function(){

		},
	},
	watch:{
	}
}

</script>


// WEBPACK FOOTER //
// src/components/agent/agent-team.vue